import React, { useMemo, useEffect } from 'react';
import Select from 'react-select';

function ValueContainer({ getValue }) {
  const filtersCount = getValue().length;
  return filtersCount ? `Выбрано ${filtersCount}` : <>&nbsp;</>;
}

function FilterMultiSelect(props) {
  const { options, onFilterChanged, placeholder, isArray } = props;
  useEffect(() => {
    if (onFilterChanged && props.MTableFiltersRef?.current?.[props.field]) {
      try {
        onFilterChanged(props.MTableFiltersRef?.current?.[props.field].map((s) => s.value));
      } catch (error) {}
    }
  }, []);
  return (
    <Select
      className="react-select-filter-Mtable"
      options={options}
      isMulti
      hideSelectedOptions={false}
      // controlShouldRenderValue={false}
      noOptionsMessage={() => 'Ничего не найдено'}
      closeMenuOnSelect={false}
      defaultValue={props.MTableFiltersRef?.current[props.field]}
      onChange={(selected) => {
        onFilterChanged(selected.map((s) => isArray ? s : s.value));
        if (props.MTableFiltersRef) {
          props.MTableFiltersRef.current[props.field] = selected;
        }
      }}
      placeholder=""
      // components={{ ValueContainer }}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999, fontSize: '12px' }),
        multiValueLabel: (base) => ({ ...base, padding: '2px 1px', paddingLeft: '1px' }),
        multiValueRemove: (base) => ({ ...base, padding: 0 }),
        valueContainer: (base) => ({
          ...base,
          padding: 0,
          alignSelf: 'start',
        }),
        // indicatorsContainer: (base, state) => ({
        //   ...base,
        //   display: 'flex',
        //   flexDirection: 'column',
        //   alignSelf: 'start',
        //   paddingTop: '4px',
        // }),
        // clearIndicator: (base) => ({ ...base, padding: '0' }),
        // dropdownIndicator: (base) => ({ ...base, padding: '0' }),
        // indicatorSeparator: (base) => ({ ...base, display: 'none' }),
        control: (base, state) => ({
          ...base,
          maxHeight: state.isFocused ? 'auto' : '55px',
          overflowY: state.isFocused ? 'visible' : 'auto',
        }),
      }}
    />
  );
}

export default function FilterMultiSelectWrapper({
  columnDef, onFilterChanged, MTableFiltersRef, field,
}, extraProps) {
  const isValueArray = Array.isArray(!!columnDef.lookup && columnDef?.lookup[0]) ?? false
  const mappedLookup = useMemo(() => {
    if (!columnDef || !columnDef.lookup) return [];
    const options = [];
    for (const [value, label] of isValueArray ? Object.values(columnDef.lookup) : Object.entries(columnDef.lookup)) options.push({ value, label });
    return options;
  }, [columnDef]);

  return <FilterMultiSelect isArray={isValueArray} options={mappedLookup} MTableFiltersRef={MTableFiltersRef} field={field} onFilterChanged={(selected) => onFilterChanged(columnDef.tableData.id, selected)} placeholder={columnDef.title} />;
}

